<template>
    <div class="flex-fill m-1 d-flex flex-column" v-loading="isLoading">
        <div class="d-flex align-items-center">
            <div class="flex-fill">
                <h5 class="mb-0">
                    <img src="/icon/staking-point.svg" style="height: 2rem;"/>
                    <strong class="ml-2">{{ $t('staking.historyTitle', { count: totalCount }) }}</strong></h5>
            </div>
            <div class="mr-2">
                <el-button size="small" round @click="refresh()"><i class="el-icon-refresh"></i> {{ $t('staking.refresh') }}</el-button>
            </div>
        </div>
        <div class="mt-3 flex-fill d-flex flex-column">
            <VuePerfectScrollbar class="pl-1 flex-fill"
                style="height: 100px;">
                <div class="pr-3">
                    <el-card class="box-card mb-2" :body-style="{ padding: '0.5rem 0.8rem' }" 
                        v-for="transaction in transactions" :key="transaction.id" >
                        <div class="d-flex flex-column flex-md-row transaction-item"
                            v-bind:class="{ 'is-canceled': transaction.isCanceled }">
                            <div class="d-flex flex-column flex-md-row flex-fill"> 
                                <div class="d-flex">
                                    <div class="aldrich-regular">
                                        <div class="text-muted"><small>{{ $t('payment.amountLabel') }}</small></div>
                                        <div><h5 style="letter-spacing: -1px;"><strong class="text-muted">{{  transaction.amount | numberFormatSpaceSperator }}</strong></h5></div>
                                    </div>
                                    <div class="ml-4">
                                        <div class="text-muted"><small>{{ $t('staking.interestRateLabel') }}</small></div>
                                        <div class="text-muted"><strong class="text-primary">{{transaction.interestRate}}%</strong>{{ $t('staking.perMonth') }}</div>
                                    </div>
                                    <div class="ml-4">
                                        <div class="text-muted"><small>{{ $t('staking.stakingDurationLabel') }}</small></div>
                                        <div class="text-muted">{{ transaction.timeStaking > 1 ? $t('staking.monthPlural', { count: transaction.timeStaking }) : $t('staking.monthSingular', { count: transaction.timeStaking }) }}</div>
                                    </div>
                                </div>
                                <div class="d-flex"> 
                                    <div class="ml-md-4 d-flex align-items-center"> 
                                        <div>
                                            <div class="d-flex align-items-center">
                                                <i class="el-icon-date  text-primary" style="font-size: 130%;"></i> 
                                                <small class="ml-1 text-muted">{{ $t('staking.fromLabel') }} {{transaction.startDate | pretyDateUtcToLocal}}</small>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <i class="el-icon-date  text-primary" style="font-size: 130%;"></i>
                                                <small class="ml-1 text-muted">{{ $t('staking.toLabel') }} {{transaction.endDate | pretyDateUtcToLocal}}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="transaction.estimatedEarning !== null && !transaction.isCanceled" class="ml-4">
                                        <div class="text-muted"><small>{{ $t('staking.estimatedEarningLabel') }}</small></div>
                                        <div class="text-muted text-right">
                                            <strong class="text-primary">~ {{transaction.estimatedEarning | numberFormatSpaceSperator}}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ml-md-6 mt-2 mt-md-0 d-flex align-items-center">
                                <div v-if="transaction.isEnded" class="text-primary">
                                    <strong>{{ $t('staking.completed') }}</strong>
                                </div>
                                <div v-else>
                                    <div v-if="transaction.isCanceled" class="text-danger">
                                        <strong>{{ $t('staking.canceled') }}</strong>
                                    </div>
                                    <el-button v-else size="small" type="danger" round @click="unstake(transaction)">
                                        {{ $t('staking.unstake') }}
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </div>
            </VuePerfectScrollbar>
            <div class="pt-3">
                <el-pagination hide-on-single-page
                    :current-page="pagination.pageIndex"
                    :page-size="pagination.pageSize"
                    layout="prev, pager, next"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.transaction-item{
    &.is-canceled{
        opacity: 0.5;
    }
}
</style>
<script>
import stakingApi from "@/api/stakingApi";
export default {
    data(){
        return {
            isLoading: false,
            pagination: {
                querySearch: "",
                pageIndex: 1,
                pageSize: 30,
                orderBy: "CreatedAt",
                directionSort: "DESC",
            },
            totalCount: 0,
            transactions: [],
        };
    },
    mounted() {
        this.getTransactionOfUser();
    },
    methods: {
        close(){
            this.$emit('close');
        },
        refresh(){
            this.pagination.pageIndex = 1;
            this.getTransactionOfUser();
        },
        getTransactionOfUser() {
            this.isLoading = true;
            stakingApi.getTransactionOfUser(this.pagination).then((res) => {
                if(res.data.result === 0){      
                    if(res.data.data) {
                        this.totalCount = res.data.data.pagination.totalCount;
                        this.transactions = res.data.data.data;
                    }         
                }                   
                this.isLoading = false;
            })
            .catch(err => {
                this.isLoading = false;
                console.error(err)
            })
        },
        unstake(transaction){
            if(!transaction.isCanceled){
                this.$confirm(this.$t('staking.unstakeConfirmMessage', {
                    amount: transaction.estimatedEarning > 0 ? transaction.estimatedEarning.toFixed(2) : this.$t('staking.allEstimated')
                }), this.$t('staking.unstakeConfirmTitle'), {
                    confirmButtonText: this.$t('staking.unstakeConfirmButton'),
                    cancelButtonText: this.$t('staking.cancel'),
                    dangerouslyUseHTMLString: true,
                    type: 'warning'
                }).then(() => {
                    this.isLoading = true;
                    stakingApi.unstakeTransaction(transaction.id)
                    .then((res) => {
                        if(res.data.result === 0){
                            this.$message({
                                type: 'success',
                                message: this.$t('staking.unstakeSuccess')
                            });
                            this.$store.dispatch("auth/basicUserInformationView");
                            this.$store.dispatch("auth/getTempBalance");
                            this.refresh();
                        }
                        else{
                            this.$message({
                                type: 'error',
                                message: this.$t('staking.genericError')
                            });
                        }
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 1000);
                    }).catch(() => {
                        this.isLoading = false;
                        this.$message({
                            type: 'error',
                            message: this.$t('staking.genericError')
                        });
                    });
                }).catch((err) => {
                    console.error(err)
                });
            }
        }
    }
}
</script>